<template>
  <div class="container asset-po-page">
    <div class="title">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>业务管理</el-breadcrumb-item>
        <el-breadcrumb-item>PO管理</el-breadcrumb-item>
        <el-breadcrumb-item>资产PO计费单</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="title-en">搜索条件</div>
    <el-card class="box-card">
      <div class="search-container">
        <el-form :inline="true" :model="searchForm" class="search-form" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="PO单号">
                <el-input v-model="searchForm.opTicketid" placeholder="请输入PO单号" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <div class="search-button">
                <el-button type="primary" @click="handleSearch">点击查询</el-button>
                <el-button @click="handleReset">重置</el-button>
                <el-button @click="debouncedExport">{{ exportButtonText }}</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <div class="title-en">资产PO计费单</div>

    <el-card class="box-card">
      <div class="table-container">
        <div class="button-container">
          <el-button @click="openColumnsDialog">表头设置</el-button>
        </div>
        <el-table
          :data="faults"
          border
          stripe
          class="asset-billing-table"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          ref="table"
          v-loading="loading"
        >
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
          <el-table-column
            v-for="(column, index) in visibleColumns"
            :key="index"
            :prop="column.prop"
            :label="column.label"
            :min-width="column.minWidth"
            :align="column.align || 'left'"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="column.prop === 'bill_info'">
                <el-button
                  type="text"
                  size="small"
                  :loading="billLoadingId === scope.row.opTicketid"
                  @click="openBillDialog(scope.row.opTicketid)"
                >
                  查看账单
                </el-button>
              </span>
              <span v-else-if="column.prop === 'resp_data'">
                <el-button
                  type="text"
                  size="small"
                  :loading="respLoadingId === scope.row.opTicketid"
                  @click="openRespDialog(scope.row.opTicketid)"
                >
                  查看响应
                </el-button>
              </span>
              <span v-else-if="column.prop === 'opTicketid'">
                <el-button
                  type="text"
                  @click="showBillingDetail(scope.row.opTicketid)"
                  style="color: #409EFF; padding: 0;"
                >
                  {{ scope.row.opTicketid }}
                </el-button>
              </span>
              <span v-else>{{ scope.row[column.prop] || '-' }}</span>
            </template>
          </el-table-column>
        </el-table>

        <el-dialog
          title="设置显示项"
          :visible.sync="showColumnsDialog"
          :append-to-body="true"
          width="400px"
          :close-on-click-modal="false"
          custom-class="columns-dialog"
          :modal-append-to-body="false"
          :destroy-on-close="true"
        >
          <el-checkbox-group v-model="selectedColumns" class="checkbox-group">
            <el-checkbox
              v-for="column in columns"
              :key="column.prop"
              :label="column.prop"
              class="checkbox-item"
            >
              {{ column.label }}
            </el-checkbox>
          </el-checkbox-group>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="selectAllColumns">全选</el-button>
            <el-button size="small" @click="restoreDefaultColumns">恢复默认</el-button>
            <el-button size="small" type="primary" @click="saveColumnsDialog">保存</el-button>
          </div>
        </el-dialog>

        <el-dialog
          :title="jsonDialogTitle"
          :visible.sync="jsonDialogVisible"
          :width="jsonDialogUseKv ? '68%' : jsonDialogTitle === '账单信息' ? '92%' : '75%'"
          custom-class="json-view-dialog asset-po-json-dialog"
          append-to-body
          top="5vh"
        >
          <json-key-value-panel
            v-if="jsonDialogVisible && jsonDialogUseKv"
            :data="jsonDialogParsed"
            class="json-view-dialog-body"
          />
          <json-nested-table
            v-else-if="jsonDialogVisible"
            :data="jsonDialogContent"
            :max-height="jsonDialogTitle === '账单信息' ? 680 : 520"
            class="json-view-dialog-body"
          />
          <span slot="footer" class="dialog-footer">
            <el-button @click="jsonDialogVisible = false">关闭</el-button>
          </span>
        </el-dialog>

        <!-- 账单明细（附表） -->
        <el-dialog
          title="账单详情"
          :visible.sync="billingDetailVisible"
          width="90%"
          custom-class="asset-po-detail-dialog"
          :before-close="closeBillingDetail"
          top="5vh"
        >
          <asset-billing-detail
            v-if="billingDetailVisible"
            :op-ticketid="selectedOpTicketid"
            :op-ticketid-exact="true"
            class="asset-po-page"
          />
          <span slot="footer" class="dialog-footer">
            <el-button @click="closeBillingDetail">关闭</el-button>
          </span>
        </el-dialog>

        <div class="pagination-container">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { assetCostConfirmBill, assetCostConfirmList, assetConfirmListAll } from '@/api/appManage';
import { getMachineList } from '@/api/workOrder';
import * as XLSX from 'xlsx';
import { debounce } from 'lodash';
import AssetBillingDetail from './asset_billing_detail.vue';
import JsonKeyValuePanel from '@/components/JsonKeyValuePanel';
import JsonNestedTable from '@/components/JsonNestedTable';
import { isSingleRowKeyValueData, parseJsonValue } from '@/utils/jsonNestedTable';
export default {
  name: 'FaultList',
  components: {
    AssetBillingDetail,
    JsonKeyValuePanel,
    JsonNestedTable,
  },
  data() {
    return {
      debouncedExport: null,
      faults: [],
      billingDetailVisible: false,
      selectedOpTicketid: '',
      jsonDialogVisible: false,
      jsonDialogTitle: '',
      jsonDialogContent: null,
      billLoadingId: '',
      respLoadingId: '',
      searchForm: {
        // createTime: [],
        // order_level: '',
        opTicketid: '',
        // serviceInfo: '',
        // campusName: '',
        // sla_level: '',
        // state: '',
        // ticket_id: '',
      },
      category_level_4Options: [
        { value: '1', label: '服务器' },
        { value: '2', label: '网络' },
        { value: '3', label: '资产' },
        { value: '4', label: '其它' },
        { value: '5', label: '人力' },
      ],
      campusNameOptions: [
        { value: 'sh-lg', label: '上海-临港' },
        { value: 'sh-sy', label: '上海-书院' },
        { value: 'hz-dg', label: '杭州-东冠' },
      ],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      showColumnsDialog: false,
      selectedColumns: ['opTicketid', 'bill_info', 'resp_data'],
      defaultSelectedColumns: ['opTicketid', 'bill_info', 'resp_data'],
      columns: [
        { prop: 'opTicketid', label: 'PO单号', minWidth: 320 },
        { prop: 'bill_info', label: '账单信息', minWidth: 200, align: 'center' },
        { prop: 'resp_data', label: '响应数据', minWidth: 200, align: 'center' },
      ],
      visibleColumns: [],
      selectedRows: [],
      machineList: [],
      loading: false,
    };
  },
  created() {
    this.visibleColumns = this.columns.filter((column) =>
      this.selectedColumns.includes(column.prop)
    );
    // const now = new Date();
    // const startDate = new Date(now.getFullYear(), now.getMonth(), 1);
    // const endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    // this.searchForm.createTime = [
    //   this.$moment(startDate).format('YYYY-MM-DD'),
    //   this.$moment(endDate).format('YYYY-MM-DD'),
    // ];
    this.handleDateChange(this.searchForm.createTime);
    this.fetchFaultData();
    // 创建防抖后的导出函数
    this.debouncedExport = debounce(this.handleExport, 300);
  },
  methods: {
    handleDateChange(dates) {
      if (dates) {
        this.searchForm.start_time = dates[0];
        this.searchForm.end_time = dates[1] + ' 23:59:59';
      } else {
        this.searchForm.start_time = '';
        this.searchForm.end_time = '';
      }
    },
    getMachineLists() {
      const params = {
        page: this.currentPage,
        size: this.pageSize,
      };
      getMachineList(params)
        .then((res) => {
          this.machineList = res.data.data.list || [];
        })
        .catch(() => {
          this.$message.error(errorMessage);
        });
    },
    async fetchFaultData() {
      const params = {
        skip: this.currentPage,
        limit: this.pageSize,
        ...Object.fromEntries(
          Object.entries(this.searchForm).filter(
            ([_, value]) => value !== '' && value !== null && value !== undefined
          )
        ),
      };
      //   // 处理日期范围
      //   if (this.searchForm.createTime && this.searchForm.createTime.length === 2) {
      //     params.start_time = this.searchForm.createTime[0];
      //     params.end_time = this.searchForm.createTime[1];
      //   }
      this.loading = true;

      try {
        let response;
        // // 添加结束时间的时分秒
        // if (params.end_time) {
        //   params.end_time = params.end_time + ' 23:59:59';
        // }
        // 使用常规的getPoList进行查询
        response = await assetCostConfirmList(params);

        if (response.data) {
          let filteredData = response.data.data.list || [];
          this.faults = filteredData;
          this.total = response.data.data.total || 0;
        }
      } catch (error) {
        console.error('请求错误:', error);
        let errorMessage = '获取数据失败';
        if (error.response && error.response.status === 422) {
          errorMessage = '请求参数格式不正确，请检查输入';
        }
        this.$message.error(errorMessage);
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      // 处理PO标题前缀
      if (this.searchForm.serviceInfo && this.searchForm.serviceInfo.startsWith('PO确认单-')) {
        this.searchForm.serviceInfo = this.searchForm.serviceInfo.replace('PO确认单-', '');
      }
      this.currentPage = 1;
      this.fetchFaultData();
    },
    handleReset() {
      this.searchForm = {
        createTime: [],
        order_level: '',
        opTicketid: '',
        serviceInfo: '',
        campusName: '',
        sla_level: '',
        state: '',
        ticket_id: '',
      };

      this.currentPage = 1;
      this.fetchFaultData();
    },
    openColumnsDialog() {
      this.showColumnsDialog = true;
    },
    saveColumnsDialog() {
      this.showColumnsDialog = false;
      this.visibleColumns = this.columns.filter((column) =>
        this.selectedColumns.includes(column.prop)
      );
    },
    selectAllColumns() {
      this.selectedColumns = this.columns.map((column) => column.prop);
    },
    restoreDefaultColumns() {
      this.selectedColumns = [...this.defaultSelectedColumns];
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchFaultData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchFaultData();
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    async handleExport() {
      this.exportLoading = true;
      try {
        if (this.selectedRows.length === 0) {
          // 导出全部数据
          this.loading = true;
          const response = await assetConfirmListAll({
            ...Object.fromEntries(
              Object.entries(this.searchForm).filter(
                ([_, value]) => value !== '' && value !== null && value !== undefined
              )
            ),
            pageSize: this.total || 9999999, // 确保获取所有数据
            currentPage: 1,
          });

          if (response.data) {
            this.loading = false;
            const allData = response.data.data.list || [];
            // 转换数据格式，确保与表格显示一致
            const worksheetData = allData.map((row) => {
              const rowData = {};
              this.visibleColumns.forEach((column) => {
                if (column.prop !== 'operation') {
                  // 排除操作列
                  let value = row[column.prop];
                  // 特殊字段处理，与表格显示保持一致
                  if (column.prop === 'poType') {
                    value = '已确认';
                  } else if (column.prop === 'isAccepted') {
                    value = row[column.prop] === 1 ? '已结单' : '待结单';
                  } else if (column.prop === 'createTime') {
                    value = row[column.prop]
                      ? this.$moment(row[column.prop]).format('YYYY-MM-DD HH:mm:ss')
                      : '-';
                  } else if (column.prop === 'dispatchType') {
                    value = '人工派单';
                  } else if (column.prop === 'dispatchStatus') {
                    value = row.engineerName ? '已派单' : '待派单';
                  } else if (column.prop === 'serviceInfo') {
                    value = value ? `PO确认单-${value}` : '-';
                  } else if (column.prop === 'bill_info') {
                    value = '（点击列表查看）';
                  } else if (column.prop === 'resp_data') {
                    value = '（点击列表查看）';
                  }
                  rowData[column.label] = value || '-';
                }
              });
              return rowData;
            });

            // 创建工作簿和工作表
            const worksheet = XLSX.utils.json_to_sheet(worksheetData);

            // 设置列宽
            const colWidths = {};
            this.visibleColumns.forEach((column, index) => {
              const width = column.minWidth ? Math.ceil(parseInt(column.minWidth) / 7) : 16;
              colWidths[XLSX.utils.encode_col(index)] = { wch: width };
            });
            worksheet['!cols'] = Object.values(colWidths);

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'PO确认单');

            // 生成文件名
            const timestamp = this.$moment().format('YYYYMMDDHHmmss');
            const filename = `PO确认单_${timestamp}.xlsx`;

            // 导出文件
            XLSX.writeFile(workbook, filename);
            this.$message.success('导出成功');
          }
        } else {
          // 导出选中数据的逻辑保持不变
          const worksheetData = this.selectedRows.map((row) => {
            const rowData = {};
            this.visibleColumns.forEach((column) => {
              if (column.prop !== 'operation') {
                // 排除操作列
                let value = row[column.prop];
                if (column.prop === 'poType') {
                  value = '已确认';
                } else if (column.prop === 'isAccepted') {
                  value = row[column.prop] === 1 ? '已结单' : '待结单';
                } else if (column.prop === 'createTime') {
                  value = row[column.prop]
                    ? this.$moment(row[column.prop]).format('YYYY-MM-DD HH:mm:ss')
                    : '-';
                } else if (column.prop === 'dispatchType') {
                  value = '人工派单';
                } else if (column.prop === 'dispatchStatus') {
                  value = row.engineerName ? '已派单' : '待派单';
                } else if (column.prop === 'serviceInfo') {
                  value = value ? `PO确认单-${value}` : '-';
                } else if (column.prop === 'bill_info') {
                  value = '（点击列表查看）';
                } else if (column.prop === 'resp_data') {
                  value = '（点击列表查看）';
                }
                rowData[column.label] = value || '-';
              }
            });
            return rowData;
          });

          const worksheet = XLSX.utils.json_to_sheet(worksheetData);

          const colWidths = {};
          this.visibleColumns.forEach((column, index) => {
            const width = column.minWidth ? Math.ceil(parseInt(column.minWidth) / 7) : 16;
            colWidths[XLSX.utils.encode_col(index)] = { wch: width };
          });
          worksheet['!cols'] = Object.values(colWidths);

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, 'PO确认单');

          const timestamp = this.$moment().format('YYYYMMDDHHmmss');
          const filename = `PO确认单_${timestamp}.xlsx`;

          XLSX.writeFile(workbook, filename);
          this.$message.success('导出成功');
        }
      } catch (error) {
        console.error('导出错误:', error);
        this.$message.error('导出失败，请重试');
      } finally {
        this.exportLoading = false;
        this.loading = false;
      }
    },
    async openBillDialog(opTicketid) {
      this.billLoadingId = opTicketid;
      try {
        const res = await assetCostConfirmBill(opTicketid);
        if (res.data && res.data.code === 200 && res.data.data) {
          this.jsonDialogTitle = '账单信息';
          this.jsonDialogContent = res.data.data.bill_info;
          this.jsonDialogVisible = true;
        } else {
          this.$message.warning(res.data?.message || '暂无账单数据');
        }
      } catch (e) {
        this.$message.error('加载账单失败');
      } finally {
        this.billLoadingId = '';
      }
    },
    async openRespDialog(opTicketid) {
      this.respLoadingId = opTicketid;
      try {
        const res = await assetCostConfirmBill(opTicketid);
        if (res.data && res.data.code === 200 && res.data.data) {
          this.jsonDialogTitle = '响应数据';
          this.jsonDialogContent = res.data.data.resp_data;
          this.jsonDialogVisible = true;
        } else {
          this.$message.warning(res.data?.message || '暂无响应数据');
        }
      } catch (e) {
        this.$message.error('加载响应数据失败');
      } finally {
        this.respLoadingId = '';
      }
    },
    showBillingDetail(opTicketid) {
      this.selectedOpTicketid = opTicketid;
      this.billingDetailVisible = true;
    },
    closeBillingDetail() {
      this.billingDetailVisible = false;
      this.selectedOpTicketid = '';
    },
  },
  computed: {
    exportButtonText() {
      return this.selectedRows.length > 0 ? `导出已选(${this.selectedRows.length})` : '导出全部';
    },
    jsonDialogParsed() {
      return parseJsonValue(this.jsonDialogContent);
    },
    jsonDialogUseKv() {
      return isSingleRowKeyValueData(this.jsonDialogParsed);
    },
  },
  watch: {
    selectedColumns(val) {
      this.selectAll = val.length === this.columns.length;
      this.isIndeterminate = val.length > 0 && val.length < this.columns.length;
    },
  },
};
</script>

<style scoped>
.container {
  padding: 20px;
}
.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}
.search-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}

.search-form {
  width: 100%;
}

.search-button {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 13px;
}

/* 调整表单项间距 */
.el-form-item {
  margin-bottom: 18px;
  display: flex;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}
.table-container {
  width: 100%;
}
.asset-billing-table {
  width: 100% !important;
}
::v-deep .asset-billing-table .el-table__header th {
  padding: 12px 0;
  font-size: 14px;
}
::v-deep .asset-billing-table .el-table__body td {
  padding: 10px 0;
}
.box-card {
  margin-bottom: 20px;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
}
.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}
.columns-dialog {
  margin-top: 0 !important;
  position: absolute !important;
  margin-left: 0 !important;
  top: 100% !important;
  left: 0 !important;
  transform: none !important;
}

.el-dialog__wrapper.columns-dialog {
  position: absolute !important;
  overflow: visible !important;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}
.checkbox-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 10px;
  max-height: 300px;
  overflow-y: auto;
}

.checkbox-item {
  margin-right: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dialog-footer {
  text-align: right;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
}

.dialog-footer .el-button + .el-button {
  margin-left: 8px;
}

/* 修改日期选择器宽度 */
::v-deep .el-date-editor.el-input__inner,
.el-date-editor--daterange.el-input__inner {
  width: 100% !important;
}

::v-deep .el-range-editor.el-input__inner {
  width: 100% !important;
}
::v-deep .el-date-editor .el-range-input {
  width: 66% !important;
}
::v-deep .el-range-editor--small .el-range-input {
  font-size: 12px !important;
}
/* 统一下拉框和输入框宽度 */
::v-deep .el-select,
.el-input {
  width: 100% !important;
}
::v-deep .el-form-item__content {
  width: calc(100% - 10px) !important;
}

/* PO单号链接样式 */
::v-deep .el-table a {
  color: #409eff;
  text-decoration: none;
  font-weight: 500;
}

::v-deep .el-table a:hover {
  color: #66b1ff;
  text-decoration: underline;
  font-weight: 500;
}
</style>
